// 「どのページの」「どのような操作に対して」「誰が行えるか」の認可を行う
const operation = {
    // ホーム画面｜カメラ直当たりの表示
    home: {
        mainCamOperation: {
            manager: true,
            poweruser: true,
            semipoweruser: true,
            generaluser: false,
            guest: false
        }
    },
    // 履歴画面｜データ削除の表示
    history: {
        historyDataDelete: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
        // 履歴画面｜プラン期間外の参照
        outOfRetentionPeriodRead: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
    },
    // サイドバー｜設定画面の表示
    sidebar: {
        settingCamLists: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
    },
    // 設定画面｜カメラ設定の表示
    setting: {
        settingCamLists: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
    },
    // カメラ設定画面｜録画開始・停止の表示、カメラ直当たりの表示
    camSetting: {
        settingCamRecOperation: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
        settingCamOperation: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        }
    },
    // カメラ詳細設定画面｜カメラ接続設定の表示、表示設定の表示
    camDetailsSetting: {
        settingCamConnection: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        },
        settingCamDisplay: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        }
    },
    // ヘルプ｜端末管理者の設定
    help: {
        helpDisplay: {
            manager: true,
            poweruser: false,
            semipoweruser: false,
            generaluser: false,
            guest: false
        }
    }
}

// 誰が、どのページの、どのような操作を行いたいのかを順に指定する
const userRoleAuthorization = (role, page, verb) => {
    if(role != "") {
        return operation[page][verb][role]
    } else {
        return false;
    }
}

export default userRoleAuthorization